export const DELETE_CONFIRMATION_TEXT =
  "This will delete the entire view. Are you sure you want to delete this view?";
